/*
 * Dreamy — événements personnalisés (S11).
 * Publiés via Shopify.analytics.publish : captés dans Réglages > Événements clients,
 * donc soumis au consentement géré par la bannière native. Aucun script tiers ici.
 */
(function () {
  var D = (window.Dreamy = window.Dreamy || {});
  var queue = [];

  D.track = function (name, data) {
    var payload = data || {};
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(name, payload);
      } else {
        queue.push([name, payload]);
      }
    } catch (e) {
      /* un événement perdu ne doit jamais casser la page */
    }
    if (window.Shopify && Shopify.designMode) console.info('[Dreamy]', name, payload);
    document.dispatchEvent(new CustomEvent('dreamy:track', { detail: { name: name, data: payload } }));
  };

  // Rejoue les événements émis avant l'initialisation de Shopify.analytics.
  window.addEventListener('load', function () {
    if (!queue.length || !(window.Shopify && Shopify.analytics)) return;
    queue.splice(0).forEach(function (e) {
      D.track(e[0], e[1]);
    });
  });

  // dreamy_faq_open : ouverture d'une question de FAQ (page produit et page FAQ).
  document.addEventListener(
    'toggle',
    function (evt) {
      var el = evt.target;
      if (!el || !el.matches || !el.matches('details[data-dreamy-faq]') || !el.open) return;
      var summary = el.querySelector('summary');
      D.track('dreamy_faq_open', { question: summary ? summary.textContent.trim() : '' });
    },
    true
  );
})();
